export default {
  init() {
    function open_toolTip(cnt) {
        var container = $('#map_container'); //toolOpened
        var cloud = $('#locationDetails .cnt');
        var append;
        if(!container.hasClass('toolOpened')) {
           container.addClass('toolOpened');
        }
        append = (cnt.img)?'<img src="'+cnt.img+'" width="350" />':'';
        append += '<h3 class="address">'+cnt.address+'</h3>';
        append += (cnt.contact)?'<p class="contact">'+cnt.contact+'</p>':'';
        append += (cnt.hours)?'<h4>OPENING HOURS:</h4><p class="hours">'+cnt.hours+'</p>':'';
        

        cloud.html(append);
    }
    function isMobile() {
      var winW = $(window).width();
      return (winW<768) ? true : false;
    }
    function initialize() {  
        
        $.getJSON('/get-json/areas/', function(data) {
          if(typeof data.status === 'undefined') {
            var map;    
            var mapOptions = {
                //zoom: 7, 
                //center: {lat: 52.3035805, lng: -6.4611776},
                panControl: true,
                disableDefaultUI: false ,
                draggable: true,
                scrollwheel: false, 
                zoomControl: true, 
                mapTypeControl: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            }; 
            map =  new google.maps.Map(document.getElementById("map_areas"),mapOptions);
            var marker;
            var markerClusterer = new MarkerClusterer(map, [], {
                //maxZoom: 10,
                //gridSize: 10,
                imagePath:'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
            });
            var bounds = new google.maps.LatLngBounds();
            $.each( data.areas, function(i, val) {
              var cord = val.coordinates.split(',');
              var pos = {lat:parseFloat(cord[0]),lng:parseFloat(cord[1])};
              var info = {
                img: (typeof val.img.sizes!=='undefined')?val.img.sizes.medium_large:'',
                address: val.address,
                contact: val.phone,
                town: val.town,
                hours: val.opening_hours,
              };
              marker = new google.maps.Marker({
                    position: pos,
                    map: map,
                    icon: data.marker.url,
                    //icon: 'https://www.google.com/mapfiles/marker_black.png',
              });
              bounds.extend(pos); 
  
              google.maps.event.addListener(marker, 'click', function() {
                  //marker.setIcon('https://www.google.com/mapfiles/marker_green.png');
                  open_toolTip(info);
                  map.setZoom(12);
                  map.setCenter(pos);
                  //marker.setIcon('https://www.google.com/mapfiles/marker_green.png');
                  $('#closeInfo').click(function(){
                    $('#map_container').removeClass('toolOpened');
                    if(!isMobile()) {
                      map.fitBounds(bounds);   
                      map.panToBounds(bounds); 
                    }
                  });
              });
              
              markerClusterer.addMarker(marker);
            }); 
            map.fitBounds(bounds);   
            map.panToBounds(bounds);
          }
        }, "json");
    }
    google.maps.event.addDomListener(window, 'load', initialize);	
     
  },
  finalize() { 

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/areas.js